import { jsx, jsxs } from "react/jsx-runtime";
import { format } from "date-fns";
import { useDateFnsLocale } from "../../appointments-picker.helpers.js";
import { AppointmentPickerDataTestIds } from "../../constants/dataTestIds.js";
import { Container, WorkingDay as WorkingDay$1, Day, Month } from "./WorkingDay.styles.js";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "@mui/material/styles";
const WorkingDay = ({ workingDate, lang }) => {
  const locale = useDateFnsLocale(lang);
  return /* @__PURE__ */ jsx(Container, { "data-testid": AppointmentPickerDataTestIds.WorkingDay, children: /* @__PURE__ */ jsxs(WorkingDay$1, { children: [
    /* @__PURE__ */ jsx(Day, { children: format(workingDate, "eee", { locale }) }),
    /* @__PURE__ */ jsx(Month, { children: format(workingDate, "MMM d", { locale }) })
  ] }) });
};
export {
  WorkingDay as default
};
